import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      let attempt = 0;
      const maxAttempts = 8;
      const delays = [50, 100, 150, 200, 250, 300, 400, 500];

      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return true;
        }
        return false;
      };

      if (!tryScroll()) {
        const tick = () => {
          if (tryScroll() || attempt >= maxAttempts) return;
          attempt += 1;
          setTimeout(tick, delays[attempt - 1] ?? 500);
        };
        tick();
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}